module.exports = __webpack_public_path__ + "static/media/iStock-846534414.09823d78.jpg";